<template>
	<div>
		<div class="content" id="header-slot">
			<p>Or with <code>header</code> slot:</p>
			<pre v-highlightjs class="box pa-0"><code class="html">&lt;ui-table :items=&quot;items&quot;&gt;
	&lt;ui-table-column prop=&quot;id&quot;&gt;
		&lt;template #header&gt;
			&lt;i class=&quot;fas fa-list-ol&quot;&gt;&lt;/i&gt;
		&lt;/template&gt;
	&lt;/ui-table-column&gt;
	&lt;ui-table-column prop=&quot;title&quot;&gt;
		&lt;template #header&gt;
			&lt;button class=&quot;button is-primary is-fullwidth&quot;&gt;Title&lt;/button&gt;
		&lt;/template&gt;
	&lt;/ui-table-column&gt;
	&lt;ui-table-column prop=&quot;body&quot;/&gt;
&lt;/ui-table&gt;</code></pre>
		</div>
		<ui-table :items="items" container-class="box">
			<ui-table-column prop="id">
				<template #header>
					<i class="fas fa-list-ol"></i>
				</template>
			</ui-table-column>
			<ui-table-column prop="title">
				<template #header>
					<button class="button is-primary is-fullwidth">Title</button>
				</template>
			</ui-table-column>
			<ui-table-column prop="body"/>
		</ui-table>
	</div>
</template>

<script>

    export default {
        name: "header-prop",
		props: {
            items: Array
		}
    }
</script>